import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsCheckboxComponent } from "./ds-checkbox.component";
import { DsIconModule } from "../ds-icon/ds-icon.module";

@NgModule({
  declarations: [DsCheckboxComponent],
  imports: [CommonModule, DsIconModule],
  exports: [DsCheckboxComponent],
})
export class DsCheckboxModule {}
